/* CAMODE collection clicks — Shopify custom event only.
   One delegated listener; the Shopify pixel system decides whether a
   consented Shopify pixel may forward the event to CAMODE.
   Requires a per-card CAMODE marker within the product-card wrapper.
   No tag is installed and no external network request is made here. */
(function () {
  if (window.__camodeCollectionClicksInstalled) return;
  window.__camodeCollectionClicksInstalled = true;

  function validId(value) {
    return /^\d{8,20}$/.test(String(value || '')) ? String(value) : null;
  }
  function publish(selection) {
    try {
      var shopify = window.Shopify;
      if (shopify && shopify.analytics &&
          typeof shopify.analytics.publish === 'function') {
        var result = shopify.analytics.publish('camode:select_item', selection);
        if (result && typeof result.catch === 'function') result.catch(function () {});
        return;
      }
    } catch (_) { /* The product navigation must never be interrupted. */ }
  }

  document.addEventListener('click', function (event) {
    var target = event.target && (event.target.closest ?
      event.target : event.target.parentElement);
    var link = target && target.closest && target.closest('a[href]');
    if (!link || link.closest('[data-camode-merchandising]')) return;
    var href;
    try {
      href = new URL(link.href, window.location.href);
      if (href.origin !== window.location.origin ||
          !/(?:^|\/)products\/[^/]+/.test(href.pathname)) return;
    } catch (_) { return; }

    // CAMODE editorial cards also use a verified Shopify product ID.
    // Emit the same consent-controlled custom event; no third-party request.
    var editorialCard = link.closest('[data-cm-discovery-product]');
    if (editorialCard) {
      var editorialId = validId(editorialCard.getAttribute('data-cm-discovery-product'));
      if (!editorialId) return;
      var module = editorialCard.closest('[data-cm-discovery-placement]');
      var placement = module && module.getAttribute('data-cm-discovery-placement') || 'outfit';
      var slot = Number(module && module.getAttribute('data-cm-discovery-slot'));
      publish({
        item_id: 'shopify_ZZ_' + editorialId,
        product_id: editorialId,
        item_name: editorialCard.getAttribute('data-cm-discovery-title') || '',
        item_list_id: 'camode_discovery_' + placement,
        item_list_name: 'CAMODE discovery - ' + placement,
        index: Number.isInteger(slot) && slot > 0 ? slot : 0
      });
      return;
    }

    // The marker must be associated with this specific card.
    var card = link.closest('.product-card-wrapper');
    var marker = link.querySelector('[data-camode-card-product-id]') ||
      (card && card.querySelector('[data-camode-card-product-id]'));
    if (!marker) return;
    var data = marker.dataset;
    var productId = validId(data.camodeCardProductId);
    if (!productId) return;
    var variantId = validId(data.camodeCardVariantId);
    // Never manufacture a variant. A product-only ID is supported by
    // CAMODE's server-side numeric product ID normalizer.
    var itemId = 'shopify_ZZ_' + productId +
      (variantId ? '_' + variantId : '');
    var listId = data.camodeCardListId ||
      (window.location.pathname.match(/\/collections\/([^/]+)/) || [])[1] || '';
    if (!listId) return; // Only collection cards with verified list context.
    var index = Number(data.camodeCardIndex);
    publish({
      item_id: itemId,
      product_id: productId,
      item_name: data.camodeCardTitle || '',
      item_list_id: listId,
      item_list_name: data.camodeCardListName || listId,
      index: Number.isInteger(index) && index >= 0 ? index : 0
    });
  }, true);
})();
